export type ConnectScanResult =
  | { kind: "trackerId"; trackerId: string }
  | { kind: "caseId"; caseId: string }
  | { kind: "user"; userId: string }
  | { kind: "place"; placeId: string };

function tryParseJsonObject(text: string): Record<string, unknown> | null {
  const trimmed = text.trim();
  try {
    const parsed: unknown = JSON.parse(trimmed);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed as Record<string, unknown>;
    }
  } catch {
    const normalized = trimmed
      .replace(/^\{/, '{"')
      .replace(/(['"])?(\w+)\1?\s*:/g, '"$2":')
      .replace(/:\s*'([^']*)'/g, ':"$1"');
    try {
      const parsed: unknown = JSON.parse(normalized);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        return parsed as Record<string, unknown>;
      }
    } catch {
      /* not JSON */
    }
  }
  return null;
}

function readStringField(obj: Record<string, unknown>, ...keys: string[]): string | null {
  for (const key of keys) {
    const value = obj[key];
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
    if (typeof value === "number" && Number.isFinite(value)) {
      return String(value);
    }
  }
  return null;
}

/** Čistě číselný kód = tracker ID; JSON s userId/place/caseId; jinak case ID. */
export function parseConnectTrackerScan(text: string): ConnectScanResult | null {
  const trimmed = text.trim();
  if (!trimmed) {
    return null;
  }

  const json = tryParseJsonObject(trimmed);
  if (json) {
    const userId = readStringField(json, "userId");
    if (userId) {
      return { kind: "user", userId };
    }

    const placeId = readStringField(json, "place", "placeId");
    if (placeId) {
      return { kind: "place", placeId };
    }

    const caseId = readStringField(json, "caseId", "caseid");
    if (caseId) {
      return { kind: "caseId", caseId };
    }

    const trackerId = readStringField(json, "trackerId", "tracker_id", "id");
    if (trackerId && /^\d+$/.test(trackerId)) {
      return { kind: "trackerId", trackerId };
    }
  }

  if (/^\d+$/.test(trimmed)) {
    return { kind: "trackerId", trackerId: trimmed };
  }

  return { kind: "caseId", caseId: trimmed };
}

export function buildIdentifierQrPayload(data: Record<string, string>): string {
  return JSON.stringify(data);
}
